import { createListModalContainer } from 'factories/ListModal'
import actions from 'actions/dashboardCharts'
import Component from 'components/DashboardCharts/Select'

export default createListModalContainer({ actions })(Component)
